<template>
  <span :class="classes">{{ productAreaText }}</span>
</template>

<script>
export default {
  props: {
    productArea: {
      type: String,
      required: true,
    },
  },
  computed: {
    productAreaText() {
      return this.productArea.charAt(0).toUpperCase() + this.productArea.slice(1);
    },
    productAreaColor() {
      const colors = {
        onboarding: 'indigo',
        recruiting: 'blue',
        team_management: 'green',
        training: 'yellow',
        offboarding: 'red',
      };
      return colors[this.productArea] || 'gray';
    },
    classes() {
      return `text-xs text-${this.productAreaColor}-700 font-light bg-${this.productAreaColor}-100 rounded-full px-2 py-1`;
    },
  },
};
</script>
